module.exports = __webpack_public_path__ + "static/media/sharonYi.c21f3cf5.jpg";